module.exports = __webpack_public_path__ + "media/img/cinematic_stock-97d76f3e.jpg";